import * as React from 'react';
import { SVGProps } from 'react';
const SvgEditLine = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.65625 17.9648C5.60625 17.9723 5.70625 17.9648 5.65625 17.9648L9.99813 17.2498C10.0481 17.2398 10.0956 17.2173 10.1306 17.1798L20.9044 6.40605L16.3956 1.89453L5.62063 12.6698C5.58313 12.7073 5.56063 12.7523 5.55063 12.8023L4.81313 17.0073C4.78881 17.1413 4.64406 17.7542 4.76548 17.9294C4.95914 18.0401 5.42578 17.9883 5.65625 17.9648ZM7.32813 13.6398L16.3956 4.57483L18.2281 6.40733L9.16063 15.4723L6.93813 15.8648L7.32813 13.6398ZM22.0006 20.0998H2V21.9998H22.0006V20.0998Z"
      fill="current"
    />
  </svg>
);
export default SvgEditLine;
